export function RichContent({ html }) {
  return (
    <div
      className="
        [all:revert]
        [&_h2]:text-2xl [&_h2]:mt-8 [&_h2]:mb-4
        [&_h3]:text-xl [&_h3]:mt-6 [&_h3]:mb-3
        [&_p]:my-4 [&_p]:text-justify
        [&_ul]:list-disc [&_ul]:pl-6
        [&_li]:my-2
      "
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
